import { StanFilterOperator, StanFilterOperatorCode } from '../types';

// Mapping from internal operator codes to URL codes
export const URL_CODE_MAP: Record<StanFilterOperator, StanFilterOperatorCode> = {
    // Number operators (direct mapping)
    '=': 'eq',
    '>': 'gt',
    '<': 'lt',
    '>=': 'gte',
    '<=': 'lte',

    // Text operators (mapped)
    like: 'li',
    between: 'bt',
};

// Mapping from internal operator codes to SQL operators
export const SQL_OPERATOR_MAP: Record<StanFilterOperatorCode, StanFilterOperator> = {
    // Number operators
    eq: '=',
    gt: '>',
    lt: '<',
    gte: '>=',
    lte: '<=',

    // Text operators
    li: 'like',
    bt: 'between',
};

/**
 * Converts internal operator code to URL code
 */
export function toUrlCode(operator: StanFilterOperator): StanFilterOperatorCode {
    return URL_CODE_MAP[operator] || operator;
}

/**
 * Converts internal operator code to SQL operator
 */
export function toSqlOperator(operatorCode: StanFilterOperatorCode): StanFilterOperator {
    return SQL_OPERATOR_MAP[operatorCode] || '=';
}

/**
 * Gets the URL code for a given operator
 */
export function getUrlCode(operator: StanFilterOperator): StanFilterOperatorCode {
    return toUrlCode(operator);
}

/**
 * Gets the SQL operator for a given operator
 */
export function getSqlOperator(operator: StanFilterOperatorCode): StanFilterOperator {
    return toSqlOperator(operator);
}
